export const getCustomersList = state => state.customersState;
